module.exports = __webpack_public_path__ + "img/img_1.26e86ee9.png";